import { useEffect, useRef } from 'react';

export default function useInterval(
  cb = () => {},
  delay = 1000,
) {
  const handler = useRef(cb);

  useEffect(() => {
    handler.current = cb;
  }, [cb]);

  useEffect(() => {
    const i = setInterval(() => handler.current(), delay);

    return () => {
      clearInterval(i);
    };
  }, []);
}
